import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Movies from "./components/MoviesView";
import Navbar from "./components/Navbar";
import MovieDetail from "./components/MoviesDetailView";
import MovieWatch from "./components/MoviesWatchView";
import { FilterContext } from "./Context/FilterContext";
import { useMemo, useState } from "react";
import { MovieContext } from "./Context/MovieContext";
import Footer from "./Footer";

function App() {
  const [Filters, setFilters] = useState({
    language: "All",
    genre: "All",
    year: "All",
  });
  const [moviesList, setmoviesList] = useState({count : 0,start : 0,movies : null,query : []});
  const FiltersProviderValue = useMemo(() => ({ Filters, setFilters }), [
    Filters,
    setFilters,
  ]);

  const MoviesListProviderValue = useMemo(
    () => ({ moviesList, setmoviesList }),
    [moviesList, setmoviesList]
  );

  return (
    <div className="App">
      <MovieContext.Provider value={MoviesListProviderValue}>
        <FilterContext.Provider value={FiltersProviderValue}>
          <Router>
            <Navbar />
            <Switch>
              <Route exact path="/">
                <Movies />
              </Route>
              <Route exact path="/movies/:slug">
                <MovieDetail />
              </Route>
              <Route path="/movies/:slug/watch">
                <MovieWatch />
              </Route>
              <Route path="/movies/:slug/:language/watch">
                <MovieWatch />
              </Route>
            </Switch>
          </Router>
        </FilterContext.Provider>
      </MovieContext.Provider>
      <Footer />
    </div>
  );
}

export default App;
